import React from 'react';
import PropTypes from 'prop-types';
import './ERidesCard.scss';
import { FormattedMessage } from 'react-intl';

const ERidesCard = ({ id, price, vehicle, title, image, link }) => {
  return (
    <a
      id={id}
      className="ERidesCard"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div
        className="ERidesCardTop"
        style={
          price === 'Local'
            ? { borderTop: '8px solid #B9BCC0' }
            : { borderTop: '8px solid #008743' }
        }
      >
        <span className="card-label">
          <FormattedMessage
            id="eRides.label"
            defaultMessage={`AUSTIN ENERGY{br}E-RIDE REBATE`}
            values={{
              br: <br />,
            }}
          />
        </span>

        <span className="card-title">
          {price === 'Local' ? (
            <FormattedMessage
              id="eRides.go"
              defaultMessage="Go"
              description="go price"
            />
          ) : (
            <FormattedMessage
              id="eRides.upTo"
              defaultMessage="Up to"
              description="up to price"
            />
          )}{' '}
          {price}{' '}
          {vehicle && (
            <FormattedMessage
              id="eRides.vehicle"
              defaultMessage="per vehicle*"
            />
          )}
        </span>
      </div>
      <div className="ERidesCardBottom">{title}</div>
      <div className="ERides-image">
        <img src={image} alt={'ERides'} className="img-fluid" />
      </div>
    </a>
  );
};

export default ERidesCard;

ERidesCard.propTypes = {
  price: PropTypes.string,
  vehicle: PropTypes.bool,
  title: PropTypes.string,
  image: PropTypes.shape({
    type: PropTypes.oneOf(['jpg', 'svg']),
  }),
};
